import React, { useState, useEffect } from "react";

import { Modal, Button, Row, Col, Spinner } from "react-bootstrap";
import moment from "moment";

import { getMail, parseMail } from "../../_helpers/api";

const MailViewer = (props) => {

  const [ mail, setMail ] = useState({});
  const [ loading, setLoading ] = useState(false);
  const [ parsedMail, setParsedMail ] = useState(null);
  const [ parsing, setParsing ] = useState(false);

  const recipientsToString = (recipients) => {
    return recipients?.map(r => r.emailAddress.address).join(", ");
  }

  useEffect(() => {
    if (props.mailId) {
      setLoading(true);
      setParsedMail(null);
      getMail(props.mailId).then((data) => {
        setMail(data);
        setLoading(false);
      });
    }
  }, [props.mailId]);

  const handleParseMail = async () => {
    setParsing(true);
    try {
      const result = await parseMail(props.mailId);
      setParsedMail(result);
    } catch (error) {
      console.error("Error parsing mail:", error);
      setParsedMail({ error: error.message });
    } finally {
      setParsing(false);
    }
  };
  
  return (
    <>
      <Modal show={props.show} onHide={props.handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Mail Viewer</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading ? <Spinner animation="border" /> : (
          <>
            <Row>
              <Col><small>From: {mail.from?.emailAddress?.address}</small></Col>
              <Col className="text-end"><small>{moment(mail.receivedDateTime).format("DD.MM.YYYY HH:mm:ss")}</small></Col>
            </Row>
            <small>To: {recipientsToString(mail.toRecipients)}</small><br />
            <small>Subject: {mail.subject}</small>
            <hr />
            <div dangerouslySetInnerHTML={{ __html: mail.body?.content }} />
            {parsedMail && (
              <>
                <hr />
                <h6>Parsed Mail JSON:</h6>
                <pre style={{ 
                  backgroundColor: '#f5f5f5', 
                  padding: '10px', 
                  borderRadius: '5px',
                  maxHeight: '400px',
                  overflow: 'auto',
                  fontSize: '12px'
                }}>
                  {JSON.stringify(parsedMail, null, 2)}
                </pre>
              </>
            )}
          </>)}
        </Modal.Body>
        <Modal.Footer>
          <small>Mail ID: {mail._id}</small>
          <Button 
            variant="primary" 
            onClick={handleParseMail}
            disabled={parsing || loading}
          >
            {parsing ? <><Spinner animation="border" size="sm" /> Parsing...</> : 'Parse Mail'}
          </Button>
          <Button variant="secondary" onClick={props.handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default MailViewer;